import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Button, Dialog, GenericTable, tCell } from "../utils";
import { buttonClasses } from "../utils/theme";
import DateRangePicker from "../utils/GenericDateRangeFilter/GenericDateRangeFilter";
import { useGetActivityLogsMutation } from "../../api/userSlice";

// export const ACTION_TYPE_OPTIONS = [
// 	{ label: "CREATE", value: "CREATE" },
// 	{ label: "UPDATE", value: "UPDATE" },
// 	{ label: "DELETE", value: "DELETE" },
// ];

const DEFAULT_PAGE = 1;
const DEFAULT_LIMIT = 10;

const CommonLogsFile = ({ open, onClose, module = "", targetId = "", name = "" }) => {
	const [getActivityLogs, { data, isLoading }] = useGetActivityLogsMutation({ fixedCacheKey: `activityLogs_${module}` });
	let { data: logs = [], count = 0, tableHeaders = [] } = data || {};
	if (!logs) logs = [];

	const defaultFilters = {
		page_no: DEFAULT_PAGE,
		pagesize: DEFAULT_LIMIT,
		start: dayjs().subtract(7, "day").toDate(),
		end: new Date(),
		// actionType: "",
	};
	const [filters, setFilters] = useState(defaultFilters);
	const { page_no, pagesize } = filters;

	const triggerFetch = (updated) => {
		getActivityLogs({
			...updated,
			module: module,
			targetId,
			start: updated.start instanceof Date ? updated.start.toISOString() : updated.start,
			end: updated.end instanceof Date ? updated.end.toISOString() : updated.end,
		});
	};

	// Fire once when the dialog opens — 0 API calls on page load.
	useEffect(() => {
		if (!open) return;
		const initFilters = {
			page_no: DEFAULT_PAGE,
			pagesize: DEFAULT_LIMIT,
			start: dayjs().subtract(7, "day").toDate(),
			end: new Date(),
			// actionType: "",
		};
		setFilters(initFilters);
		triggerFetch(initFilters);
	}, [open]);

	const handleDateRangeSelect = (range) => {
		if (!range) return;
		const updated = {
			...filters,
			page_no: DEFAULT_PAGE,
			start: new Date(range.startDate),
			end: new Date(range.endDate),
		};
		setFilters(updated);
		triggerFetch(updated);
	};

	// const handleActionTypeChange = (option) => {
	// 	const updated = { ...filters, page: DEFAULT_PAGE, actionType: option?.value || "" };
	// 	setFilters(updated);
	// 	triggerFetch(updated);
	// };

	const handleResetFilters = () => {
		setFilters(defaultFilters);
		triggerFetch(defaultFilters);
	};

	const onPageChange = (newPage) => {
		const updated = { ...filters, page_no: newPage + 1 };
		setFilters(updated);
		triggerFetch(updated);
	};

	const onPageSizeChange = (e) => {
		const updated = { ...filters, page_no: DEFAULT_PAGE, pagesize: e.target.value };
		setFilters(updated);
		triggerFetch(updated);
	};

	const header = ["S.no", ...tableHeaders.map((h) => h.label)];

	const getNestedValue = (obj, path) => {
		return path.split(".").reduce((acc, key) => acc?.[key], obj);
	};

	const rows = logs.map((d, i) => {
		const row = [tCell((page_no - 1) * pagesize + i + 1)];
		tableHeaders.forEach((h) => {
			let val = getNestedValue(d, h.name);
			if (h.format === "datetime" || h.name === "timestamp") {
				val = val ? dayjs(val).format("DD MMM YYYY, hh:mm:ss A") : "-";
			} else if (Array.isArray(val)) {
				val = val.join(", ") || "-";
			} else {
				val = val ?? "-";
			}
			row.push(tCell(val));
		});
		return row;
	});

	return (
		<Dialog
			size="xl"
			open={open}
			handleClose={onClose}
			noBtn
			minHeight="80vh"
			title={`Activity Logs${name ? ` (${name})` : ""}`}
		>

			<div
				style={{
					display: "flex",
					flexWrap: "wrap",
					alignItems: "flex-end",
					gap: "8px",
					marginBottom: "12px",
				}}
			>
				<div>
					<DateRangePicker
						onDateRangeSelect={handleDateRangeSelect}
						initialStartDate={filters.start}
						initialEndDate={filters.end}
						isHourTime={false}
					/>
				</div>

				{/* <div style={{ maxWidth: "180px", minWidth: "180px" }}>
					<Dropdown
						id="actionType"
						name="actionType"
						label="Action Type"
						options={actionTypeOptions}
						value={actionTypeValue}
						onChange={handleActionTypeChange}
					/>
				</div> */}

				<div >
					<Button
						text="Clear"
						onClick={handleResetFilters}
						style={{ ...buttonClasses.lynkitOrangeEmpty, minHeight: "39px" }}
					/>
				</div>
			</div>

			{/* ── Table ── */}
			<GenericTable
				header={header}
				rows={rows}
				pageCount={count}
				pageNo={page_no}
				limit={pagesize}
				onPageChange={onPageChange}
				onPageSizeChange={onPageSizeChange}
				isLoading={isLoading}
			/>
		</Dialog>
	);
};

export default CommonLogsFile;
